import React, { useState } from "react";
import propTypes from "prop-types";
import classnames from "classnames";
import Icon from "../icons/Icon";
import { createDataAttributes } from "../../utilities";
import "./Alert.scss";

const Alert = ({
  label,
  children,
  type,
  dismissible,
  onDismiss,
  className,
  block,
  dataAttrib,
  ...rest
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const closeAlert = () => {
    setIsVisible(false);
    if (onDismiss) {
      onDismiss(false);
    }
  };

  const classes = classnames(
    className,
    "uikit__alert",
    "uikit__alert__" + type,
    { uikit__alert__block: block }
  );
  return (
    <>
      {isVisible && (
        <div
          className={classes}
          {...rest}
          {...createDataAttributes(dataAttrib)}
        >
          <span className="uikit__alert__content">
            {label && <span className="uikit__alert__label">{label}</span>}
            <span className="uikit__alert__message">{children}</span>
          </span>
          {dismissible && (
            <button className="uikit__alert__dismiss" onClick={closeAlert}>
              <Icon icon="fasTimes" />
            </button>
          )}
        </div>
      )}
    </>
  );
};

Alert.propTypes = {
  label: propTypes.oneOfType([propTypes.string, propTypes.element]),
  children: propTypes.oneOfType([
    propTypes.string,
    propTypes.element,
    propTypes.node
  ]).isRequired,
  type: propTypes.oneOf(["plain", "note", "warning", "error", "success"]),
  dismissible: propTypes.bool,
  onDismiss: propTypes.func,
  className: propTypes.string,
  block: propTypes.bool,
  dataAttrib: propTypes.arrayOf(Object)
};

Alert.defaultProps = {
  type: "note",
  dismissible: true,
  block: false
};

export default Alert;
